/* eslint-disable react-hooks/exhaustive-deps */
import CheckboxCustom from "@lhd/components/CheckboxCustom";
import {
  useCascadingFilter,
  useCreateRecordV2,
  useDeleteRecordsV2,
  useFetchOneAppByTypeV2,
  useFetchOrgs,
  useFetchRecordsV2,
  useGetSelectOptionByAppPartType,
  useUpdateRecordV2,
} from "@lhd/hooks";
import {
  AppRecordV2,
  AppRecordValueV2,
  AppTypes,
  CONTRACT_STATUS,
  DISPLAY_SIZES,
  IOptions,
  IPermissionItem,
} from "@lhd/types";
import { Form, Spin } from "antd";
import {
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  buildAppPartTypeObject,
  buildTreeAppPartType,
  convertTableFilter,
  dataDataValueToForm,
  dataFormToDataSubmit,
  flattenAppParts,
  getStatusContractText,
  getValueFormatByAppPart,
  handleHiddenAndSortAppPartColumns,
  renderField,
} from "../../untils";

import ButtonCommonArrow from "@lhd/components/ButtonCommonArrow";
import ButtonQuickView from "@lhd/components/ButtonQuickView";
import { getDisplaySize } from "@lhd/components/DisplaySizeSelector/selector";
import FilterIcon from "@lhd/components/FilterIcon";
import { Column } from "@lhd/components/TableDiv";
import {
  BUTTON_HEIGHT,
  DISABLED_FIELD_CODES_BY_APP_TYPE,
  FONT_SIZE,
  FONT_SIZE_VALUE,
  ROUTES,
} from "@lhd/constants";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { parsePositiveIntWithDefault } from "@lhd/features/TrackingTime/until";
import { getCompanyId, clearSortFromOtherColumns } from "@lhd/utility";
import { Tooltip } from "antd";
import { get, isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Title from "../../components/Title";
import {
  APP_TYPES,
  BACK_NAVIGATE_URL_KEY,
  ROLE_SIGNATURE,
  SELECTIONS_APP_PARTS,
} from "../../constants";
import { useUploadStatus } from "../../contexts/UploadStatusContext";
import CellValue from "./components/CellValue";
import { useAppListTableReorderResize } from "./useAppListTableReorderResize";
import { useSearchAreaBoxFilterSync } from "@lhd/components/SearchAreaBox/hooks/useSearchAreaBoxFilterSync";

export interface ReceivedProps {
  appType: AppTypes;
  url: string;
  permission: IPermissionItem;
  hasQuickView?: boolean;
  disableQuickView?: boolean;
  isWorker?: boolean;
  companyId?: number;
  workerId?: number;
  defaultContractStatusOnCreate?: boolean;
  showCopyButton?: boolean;
  hideCreateButtons?: boolean;
  isRecordEditable?: (record: AppTableRow) => boolean;
  isRecordDeletable?: (record: AppTableRow) => boolean;
  configShowBtnsOnHeader?: {
    showDelete?: boolean;
    showShare?: boolean;
    showToSheet?: boolean;
    showAddNew?: boolean;
    disableDelete?: boolean;
    disableShare?: boolean;
    disableToSheet?: boolean;
    disableAddNew?: boolean;
    typeShare?: "multiple" | "single" | string;
    showUndoRedoButtons?: boolean;
    showViewModeSwitch?: boolean;
    hideAddNewRecordButton?: boolean;
  };
  configBtnQuickView?: {
    disableEdit?: boolean;
    disableView?: boolean;
  };
  configActionDisabledColumns?: {
    checkbox?:
      | boolean
      | ((record: AppRecordV2, appParts?: AppPartType[]) => boolean);
    reorder?: boolean;
    editRow?: boolean | ((record: AppRecordV2) => boolean);
    openQuickView?: boolean;
    hideCheckbox?: boolean;
  };
  configActionBtnsOnRow?: {
    checkbox?: boolean;
    reorder?: boolean;
    editRow?: boolean;
    openQuickView?: boolean;
  };
  showColumnAction?: boolean;
  renderButtonAction?: (
    record: AppRecordV2,
    refetchRecords?: () => void,
  ) => React.ReactNode;
  additionalFilter?: Record<string, any>;
  hiddenPaginationInURL?: boolean;
  renderExtendActionHeader?: () => ReactNode;
  statusFilterSelected?: any[];
  setStatusFilterSelected?: React.Dispatch<React.SetStateAction<any[]>>;
  categoryFilterSelected?: any[];
  setCategoryFilterSelected?: React.Dispatch<React.SetStateAction<any[]>>;
  statusKeys?: string[];
  categoryKeys?: string[];
  quickButtonDirection?: "vertical" | "horizontal";
  forceCloseQuickViewSignal?: number;
}

export type AppTableRow = {
  id: number;
  isNew?: boolean;
  key: string;
  contract_info?: AppRecordV2["contract_info"];
  itemRecord: AppRecordV2;
} & Record<string, AppRecordValueV2>;

const KEY_RECORD_ADD_NEW = "new";
const filterValueEmpty = (val: any, appType: string) => {
  if (appType !== APP_TYPES.BUSINESS_TRIP_REPORTS) return val;
  return Object.keys(val).reduce((acc: any, key) => {
    const _val = val[key];
    if (_val !== null && _val !== "") {
      acc[key] = _val;
    }
    return acc;
  }, {});
};
const useAppList = ({
  appType,
  url,
  permission,
  hasQuickView,
  disableQuickView,
  isWorker,
  showColumnAction,
  defaultContractStatusOnCreate = false,
  showCopyButton,
  hideCreateButtons,
  isRecordEditable,
  isRecordDeletable,
  workerId,
  companyId = Number(getCompanyId()),
  configActionDisabledColumns,
  configShowBtnsOnHeader,
  configActionBtnsOnRow,
  renderButtonAction,
  additionalFilter,
  configBtnQuickView,
  hiddenPaginationInURL,
  ...restProps
}: ReceivedProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const viewType = searchParams.get("view_type");
  const year = searchParams.get("year");
  const refetchRecordsRef = useRef<() => void>();
  const refTable = useRef<HTMLDivElement>(null);
  const newRowKeyPrefixRef = useRef(`new-${Date.now()}`);
  const uploadStatus = useUploadStatus();
  const [form] = Form.useForm();
  const [recordIdEditing, setRecordEditing] = useState<any>(null);
  const [selectedRecordIds, setSelectedRecordIds] = useState<number[]>([]);
  const [isOpenDeletedModal, setIsOpenDeletedModal] = useState(false);
  const [isOpenShareModal, setIsOpenShareModal] = useState(false);
  const [numberRowAddNew, setNumberRowAddNew] = useState(0);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [isOpenQuickView, setIsOpenQuickView] = useState(false);
  const [idSelected, setIdSelected] = useState<{
    recordId?: string;
    appId?: string;
  }>({
    recordId: "",
    appId: "",
  });
  const [isDisabledEdit, setDisabledEdit] = useState(true);
  const [enableIdsDeleteRecord, setEnableIdsDeleteRecord] = useState<number[]>(
    [],
  );
  const [enableIdsShareRecord, setEnableIdsShareRecord] = useState<number[]>(
    [],
  );
  //for component when quick view
  const [params, setParams] = useState({
    page: 1,
    pageSize: 50,
  });
  const page = parsePositiveIntWithDefault(searchParams.get("page"), 1);
  const pageSize = parsePositiveIntWithDefault(
    searchParams.get("per_page"),
    50,
  );
  const { data: dataAppRaw, isLoading: isLoadingApp } = useFetchOneAppByTypeV2(
    appType,
    companyId,
  );

  const appParts = useMemo(
    () =>
      handleHiddenAndSortAppPartColumns(
        buildTreeAppPartType(dataAppRaw?.app_parts || []),
      ),
    [dataAppRaw],
  );

  const {
    columnWidths,
    orderedAppParts,
    sortableItems,
    handleDragEnd,
    getWidthByAppPart,
    isReordering,
    columnOrder,
    handleColumnWidthsChange,
    handleColumnWidthsEnd,
    handleColumnOrderChange,
    isSubmittingUserColumnSettings,
    appTypeUserRecordPermissions,
  } = useAppListTableReorderResize({
    appType,
    appId: dataAppRaw?.id ? String(dataAppRaw.id) : "",
    appParts: appParts || [],
    dataSource,
    setDataSource,
    refetchRecords: () => refetchRecordsRef.current?.(),
    isEditing: !!recordIdEditing,
    companyId,
  });
  const appPartUserRecordPermissions = useMemo(() => {
    return (appTypeUserRecordPermissions as readonly string[]).includes(
      appType,
    );
  }, [appType, appTypeUserRecordPermissions]);

  const resolvedStatusKeys = useMemo(() => {
    const flatParts = flattenAppParts(appParts || []);
    const keys = (restProps.statusKeys || []).map((key) => {
      const matched = flatParts.find(
        (ap) =>
          ap.field_code === key || String(ap.id) === key || ap.name === key,
      );
      return matched ? String(matched.id) : key;
    });
    return Array.from(new Set(keys));
  }, [restProps.statusKeys, appParts]);

  const resolvedCategoryKeys = useMemo(() => {
    const flatParts = flattenAppParts(appParts || []);
    const keys = (restProps.categoryKeys || []).map((key) => {
      const matched = flatParts.find(
        (ap) =>
          ap.field_code === key || String(ap.id) === key || ap.name === key,
      );
      return matched ? String(matched.id) : key;
    });
    return Array.from(new Set(keys));
  }, [restProps.categoryKeys, appParts]);

  const { filterInfo, setFilterInfo } = useCascadingFilter<AppPartType>({
    columns: flattenAppParts(orderedAppParts || []),
    getColumnId: (col: AppPartType) => String(col.id),
    statusKeys: resolvedStatusKeys,
    categoryKeys: resolvedCategoryKeys,
  });

  const { syncOpenFilterWithSearchBox } = useSearchAreaBoxFilterSync({
    filterInfo: filterInfo as any,
    setFilterInfo: setFilterInfo as any,
    statusKeys: resolvedStatusKeys,
    categoryKeys: resolvedCategoryKeys,
    controlledStatusFilterSelected: restProps.statusFilterSelected,
    setControlledStatusFilterSelected: restProps.setStatusFilterSelected,
    controlledCategoryFilterSelected: restProps.categoryFilterSelected,
    setControlledCategoryFilterSelected: restProps.setCategoryFilterSelected,
  });

  const filter = filterInfo.filter || {};

  const appId = useMemo(() => {
    return dataAppRaw?.id ? String(dataAppRaw.id) : "";
  }, [dataAppRaw]);

  const [isEnableDeleteBtn, isEnableShareBtn] = useMemo(() => {
    return [
      selectedRecordIds?.every((id) => enableIdsDeleteRecord.includes(id)),
      selectedRecordIds?.some((id) => enableIdsShareRecord.includes(id)),
    ];
  }, [enableIdsDeleteRecord, enableIdsShareRecord, selectedRecordIds]);

  const {
    data: dataRecordRaw,
    isLoading: isLoadingRecord,
    isFetching: isFetchingRecord,
    refetch: refetchRecords,
  } = useFetchRecordsV2({
    appType,
    appId,
    params: hiddenPaginationInURL
      ? params
      : {
          page: page,
          pageSize: pageSize,
        },
    filter: {
      ...convertTableFilter(filter, appParts || [], appType),
      ...additionalFilter,
    },
    canView: permission?.view,
    workerId,
    companyId,
  });

  useEffect(() => {
    refetchRecordsRef.current = refetchRecords;
  }, [refetchRecords]);

  const total = dataRecordRaw?.meta.total || 0;
  const totalPages = dataRecordRaw?.meta.total_page || 1;
  const isDisabledView = !permission?.view;

  const { mutateAsync: createRecordAsync, isLoading: isCreating } =
    useCreateRecordV2({
      appType,
      appId,
      companyId,
    });
  const { mutateAsync: updateRecordAsync, isLoading: isUpdating } =
    useUpdateRecordV2({
      appType,
      appId,
      companyId,
    });
  const { mutateAsync: deleteRecordsAsync, isLoading: isDeleting } =
    useDeleteRecordsV2({
      appType,
      appId,
      companyId,
    });

  const navigate = useNavigate();
  const location = useLocation();

  const displaySize =
    (useSelector(getDisplaySize) as
      | keyof typeof FONT_SIZE
      | keyof typeof BUTTON_HEIGHT) || DISPLAY_SIZES.SMALL;
  const isEditing = !!recordIdEditing || !!numberRowAddNew;

  const fontSize = FONT_SIZE_VALUE[displaySize ?? DISPLAY_SIZES.SMALL];
  const height = BUTTON_HEIGHT[displaySize] ?? BUTTON_HEIGHT.small;

  const dataRecord = useMemo(() => dataRecordRaw?.data || [], [dataRecordRaw]);
  const selectionDataListRaw = useGetSelectOptionByAppPartType(
    appParts,
    String(companyId),
  );

  const { data: allOrgsData } = useFetchOrgs(1, 9999, undefined, !companyId);

  const flattenOrgs = useMemo(() => {
    return allOrgsData?.data?.flatMap((org: any) => {
      if (!org.org_nodes || org.org_nodes.length === 0) return [org];
      return [org, ...org.org_nodes];
    });
  }, [allOrgsData]);

  const selectionDataList = useMemo(() => {
    if (!flattenOrgs?.length) return selectionDataListRaw;
    return {
      ...selectionDataListRaw,
      ...(appType === APP_TYPES.BUSINESS_TRIP_REPORTS
        ? {
            department_selection: flattenOrgs,
          }
        : {}),
    };
  }, [selectionDataListRaw, flattenOrgs, appType]);

  const handleSave = async (recordId: string | number) => {
    const key = recordId || KEY_RECORD_ADD_NEW;
    const valuesRaw = get(form.getFieldsValue(), key, {});
    const values = { ...valuesRaw };
    if (!recordId && defaultContractStatusOnCreate) {
      const statusAppPart = appParts.find(
        (appPart) => appPart.app_part_type === APP_PART_TYPES.STATUS_CONTRACT,
      );

      if (statusAppPart) {
        const statusFieldKey = String(statusAppPart.id);
        const statusValue = values[statusFieldKey];
        const isEmptyStatus = statusValue === "" || statusValue == null;

        if (isEmptyStatus) {
          values[statusFieldKey] = CONTRACT_STATUS.DRAFTING;
        }
      }
    }

    // Filter fields disable based on app type (e.g., ステータス, application_creator, ... in business_trip_reports)
    const disabledFieldCodes = DISABLED_FIELD_CODES_BY_APP_TYPE[appType] || [];

    const filteredValues = disabledFieldCodes.length
      ? Object.fromEntries(
          Object.entries(values).filter(([fieldId]) => {
            const appPart = appParts.find((ap) => String(ap.id) === fieldId);
            if (!appPart) return true;

            return (
              !disabledFieldCodes.includes(appPart.field_code ?? "") &&
              !disabledFieldCodes.includes(appPart.name ?? "")
            );
          }),
        )
      : values;

    const payload = {
      values: filterValueEmpty(
        dataFormToDataSubmit(
          filteredValues,
          buildAppPartTypeObject(appParts),
          appType,
        ),
        appType,
      ),
    };

    if (appType === APP_TYPES.COMPANY_POLICIES) {
      appParts.forEach((appPart) => {
        if (
          appPart.parent_id == null &&
          appPart.app_part_type === APP_PART_TYPES.MULTI_CHOICE &&
          (appPart.field_code === "カテゴリー" ||
            appPart.name === "カテゴリー" ||
            appPart.label_text === "カテゴリー")
        ) {
          const fieldId = String(appPart.id);
          if (
            payload.values[fieldId] === undefined ||
            payload.values[fieldId] === null
          ) {
            payload.values[fieldId] = [];
          }
        }
      });
    }

    if (appType === APP_TYPES.BUSINESS_MANUALS) {
      appParts.forEach((appPart) => {
        if (
          appPart.parent_id == null &&
          (appPart.field_code === "カテゴリ" ||
            appPart.field_code === "category" ||
            appPart.name === "カテゴリ" ||
            appPart.name === "カテゴリー")
        ) {
          const fieldId = String(appPart.id);
          if (payload.values[fieldId] === undefined) {
            payload.values[fieldId] = [];
          }
        } else if (
          appPart.parent_id == null &&
          (appPart.field_code === "status_slicer" ||
            appPart.field_code === "status_filter" ||
            appPart.name === "ステータス")
        ) {
          const fieldId = String(appPart.id);
          if (payload.values[fieldId] === undefined) {
            const defNum = Number(appPart.default_value);
            payload.values[fieldId] =
              appPart.default_value !== undefined &&
              appPart.default_value !== null &&
              appPart.default_value !== "" &&
              Number.isInteger(defNum)
                ? defNum
                : null;
          }
        }
      });
    }

    if (recordId) {
      await updateRecordAsync({
        payload,
        recordId,
      });

      await refetchRecords();
      setRecordEditing(null);
    } else {
      await createRecordAsync({
        payload,
      });
      await refetchRecords();
      setNumberRowAddNew(0);
    }
    form.resetFields();
  };
  // deleted

  const handleUnSelectedOrSelected = (id: number, checked: boolean) => {
    setSelectedRecordIds((prev) => {
      if (checked) {
        if (prev.includes(id)) return prev;
        return [...prev, id];
      } else {
        return prev.filter((x) => x !== id);
      }
    });
  };

  const handleUnSelectedOrSelectedAll = (checked: boolean) => {
    setSelectedRecordIds(() => {
      if (checked) {
        return [...enabledIds];
      } else {
        return [];
      }
    });
  };

  const handleDelete = async () => {
    if (selectedRecordIds?.length === 0) return;
    await deleteRecordsAsync(
      {
        payload: { delete_ids: selectedRecordIds },
      },
      {
        onError: () => {
          setSelectedRecordIds([]);
          onCancelModalDelete();
        },
      },
    );
    setSelectedRecordIds([]);
    onCancelModalDelete();
    await refetchRecords();
    if (selectedRecordIds.includes(Number(idSelected.recordId))) {
      handleCloseQuickView();
    }
  };

  const handleOpenModalDelete = () => {
    setIsOpenDeletedModal(true);
  };

  const onCancelModalDelete = () => {
    setIsOpenDeletedModal(false);
  };

  const handleOpenModalShare = () => {
    setIsOpenShareModal(true);
  };

  const onCancelModalShare = () => {
    setIsOpenShareModal(false);
  };
  // done deleted

  // add new
  const handleAddNewRow = (numberRecordAddNew: number) => {
    form.resetFields();
    setNumberRowAddNew(numberRecordAddNew);
  };
  //done add new

  const handleNavigateCreatePage = () => {
    const params = new URLSearchParams({
      [BACK_NAVIGATE_URL_KEY]: `${location.pathname}${location.search}`,
      ...(viewType && { view_type: viewType }),
      ...(year && { year }),
    });

    const createPath = (
      [
        APP_TYPES.COMPANY_POLICIES,
        APP_TYPES.FINANCIAL_REPORTS,
        APP_TYPES.BUSINESS_TRIP_REPORTS,
        APP_TYPES.ROLE_PERMISSIONS,
        APP_TYPES.BUSINESS_FLOW,
        APP_TYPES.BUSINESS_MANUALS,
      ] as AppTypes[]
    ).includes(appType)
      ? `/${url}/${appId}/${ROUTES.CREATE}?${params}`
      : `/${url}/${appId}/${ROUTES.CREATE}/${companyId}?${params}`;

    navigate(createPath);
  };

  const handleNavigateSheetPage = () => {
    const params = new URLSearchParams({
      [BACK_NAVIGATE_URL_KEY]: `${location.pathname}${location.search}`,
    });

    const sheetPath = `/${url}/${appId}/${ROUTES.SHEET}?${params}`;
    navigate(sheetPath);
  };

  const getSignedDateValue = (
    appPart: AppPartType,
    recordItem: AppRecordV2,
  ) => {
    if (appPart.app_part_type !== APP_PART_TYPES.SIGNED_DATE) return null;

    const signaturePartId = (
      appPart as AppPartType & {
        app_part_relation_id?: string | number;
      }
    ).app_part_relation_id;
    if (!signaturePartId) return null;

    return recordItem.contract_info?.signatures?.find(
      (signature) => String(signature.part_id) === String(signaturePartId),
    )?.signed_at;
  };

  const computedDataSource = useMemo(() => {
    // 1. Existing rows
    if (!appParts?.length) return [];
    const existedRows = dataRecord.map((itemRecord) => {
      const item: Record<string, AppRecordValueV2> = {};

      const appRecordObject = itemRecord.regular_values.reduce((acc, cur) => {
        acc[String(cur.app_part_id)] = cur;
        return acc;
      }, {} as Record<string, typeof itemRecord.regular_values[number]>);

      appParts.forEach((appPart) => {
        const keyOf = String(appPart.id);
        const recordValue = appRecordObject[keyOf];
        const signedDateValue = getSignedDateValue(appPart, itemRecord);
        if (
          appType === APP_TYPES.BUSINESS_TRIP_REPORTS &&
          (appPart.field_code === "ステータス" ||
            String(appPart.id) ===
              String(
                (itemRecord as any)?.business_trip_report_info?.status_field_id,
              ))
        ) {
          item[keyOf] = {
            ...recordValue,
            valueFormat:
              (itemRecord as any)?.business_trip_report_info?.status_label ||
              (itemRecord as any)?.business_trip_report_info?.status ||
              "",
            value: (itemRecord as any)?.business_trip_report_info?.status || "",
          };
        } else if (appPart.app_part_type === APP_PART_TYPES.STATUS_CONTRACT) {
          item[keyOf] = {
            ...recordValue,
            valueFormat: getStatusContractText(
              itemRecord?.contract_info?.contract_status || "",
            ),
            value: itemRecord?.contract_info?.contract_status || "",
          };
        } else if (
          appPart.app_part_type === APP_PART_TYPES.NUMBER &&
          appType === APP_TYPES.FINANCIAL_REPORTS
        ) {
          const rawValue: string = recordValue?.value || "";
          const cleaned = rawValue.replace(/[^\d.]/g, "");
          if (cleaned === "") {
            item[keyOf] = {
              ...recordValue,
              valueFormat: "",
            };
          } else {
            item[keyOf] = {
              ...recordValue,
              valueFormat: rawValue,
            };
          }
        } else if (recordValue) {
          item[keyOf] = {
            ...recordValue,
            valueFormat: getValueFormatByAppPart(
              appPart,
              recordValue,
              selectionDataList,
            ),
          };
        } else if (signedDateValue) {
          item[keyOf] = {
            id: Number(keyOf),
            app_part_id: Number(keyOf),
            value: signedDateValue,
            background_color: null,
            text_color: null,
            valueFormat: getValueFormatByAppPart(appPart, {
              value: signedDateValue,
            } as AppRecordValueV2),
          } as AppRecordValueV2;
        }
      });

      const recordKey = String((itemRecord as any).key ?? itemRecord.id);
      return {
        id: itemRecord.id,
        key: recordKey,
        itemRecord,
        ...item,
      };
    });

    // 2. New rows (empty)
    const newRows = Array.from({ length: numberRowAddNew }).map((_, index) => {
      const item: Record<string, AppRecordValueV2> = {};

      appParts.forEach((appPart) => {
        const keyOf = String(appPart.id);

        item[keyOf] = {
          app_part_id: appPart.id,
          value: "",
          valueFormat: "",
        } as any as AppRecordValueV2;
      });

      return {
        key: `${newRowKeyPrefixRef.current}-${index}`,
        contract_info: {
          contract_status: CONTRACT_STATUS.DRAFTING,
          signatures: [],
        },
        ...item,
        isNew: true, // optional flag
      };
    });

    // 3. Merge
    return [...existedRows, ...newRows];
  }, [appParts, dataRecord, numberRowAddNew, selectionDataList]);

  useEffect(() => {
    setDataSource(computedDataSource);
  }, [computedDataSource]);
  const enabledIds = useMemo(() => {
    if (
      isEditing ||
      (!permission?.delete &&
        !permission?.edit &&
        !appPartUserRecordPermissions)
    )
      return [];
    if (appPartUserRecordPermissions) {
      const data = dataSource?.filter((item) => {
        if (
          !item.id ||
          item.isNew ||
          !item?.itemRecord?.policy_permissions?.record_edit
        )
          return false;

        const canDeleteRecord = isRecordDeletable
          ? isRecordDeletable(item)
          : true;

        const isCheckboxDisabled =
          typeof configActionDisabledColumns?.checkbox === "function"
            ? configActionDisabledColumns.checkbox(
                item.itemRecord as AppRecordV2,
                appParts,
              )
            : !!configActionDisabledColumns?.checkbox || !canDeleteRecord;

        return !isCheckboxDisabled;
      });
      const recordsCanDelete =
        data
          ?.filter(
            (item) => item?.itemRecord?.policy_permissions?.record_delete,
          )
          ?.map((item) => item.id) || [];
      const recordsCanShare =
        data
          ?.filter((item) => item?.itemRecord?.policy_permissions?.record_edit)
          ?.map((item) => item.id) || [];
      setEnableIdsDeleteRecord(recordsCanDelete);
      setEnableIdsShareRecord(recordsCanShare);
      return data.map((item) => item.id) || [];
    }
    return (
      dataSource
        ?.filter((item) => {
          if (!item.id || item.isNew) return false;

          const canDeleteRecord = isRecordDeletable
            ? isRecordDeletable(item)
            : true;

          const isCheckboxDisabled =
            typeof configActionDisabledColumns?.checkbox === "function"
              ? configActionDisabledColumns.checkbox(
                  item.itemRecord as AppRecordV2,
                )
              : !!configActionDisabledColumns?.checkbox || !canDeleteRecord;

          return !isCheckboxDisabled;
        })
        .map((item) => item.id) || []
    );
  }, [
    dataSource,
    configActionDisabledColumns?.checkbox,
    isEditing,
    permission?.delete,
    permission?.edit,
    isRecordDeletable,
    appPartUserRecordPermissions,
    appParts,
  ]);

  const columnAction = useMemo(() => {
    const selectableCount = enabledIds.length;
    return {
      title: (
        <div className="gap-2 flex-center column-action-header">
          {!configActionDisabledColumns?.hideCheckbox && (
            <div className="pl-2 d-flex">
              <CheckboxCustom
                displaySize={displaySize}
                checked={
                  selectableCount > 0 &&
                  selectedRecordIds.length > 0 &&
                  selectedRecordIds.length === selectableCount
                }
                disabled={enabledIds.length === 0}
                indeterminate={
                  selectedRecordIds.length > 0 &&
                  selectedRecordIds.length < selectableCount
                }
                onChange={(e) =>
                  handleUnSelectedOrSelectedAll(e.target.checked)
                }
                label={{
                  content: "全選択",
                }}
              />
            </div>
          )}
        </div>
      ),
      dataIndex: "columnAction",
      key: "columnAction",
      autoWidth: true,
      fixed: "left",
      render(value, record, index, dragHandleProps) {
        const isEditingCurrentRecord =
          (record.id === recordIdEditing && !numberRowAddNew) || record.isNew;

        let recordPermission = {
          record_delete: true,
          record_edit: true,
          record_view: true,
        };
        if (appPartUserRecordPermissions) {
          recordPermission = record?.itemRecord?.policy_permissions;
        }

        const isDragDisabled =
          isEditing ||
          (appPartUserRecordPermissions
            ? !recordPermission?.record_edit
            : !permission?.edit && !permission?.delete) ||
          configActionDisabledColumns?.reorder;

        const canEditRecord = isRecordEditable
          ? isRecordEditable(record)
          : true;
        const canDeleteRecord = isRecordDeletable
          ? isRecordDeletable(record)
          : true;
        const isNoPermissionForDeleteCheckbox = appPartUserRecordPermissions
          ? !recordPermission?.record_edit
          : !permission?.delete && !permission?.edit;

        return (
          <div>
            <div className="gap-2 flex-center px-1">
              {!record.isNew &&
                !configActionDisabledColumns?.hideCheckbox &&
                (isNoPermissionForDeleteCheckbox ? (
                  <Tooltip title="権限がありません" trigger="hover">
                    <span
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <CheckboxCustom
                        displaySize={displaySize}
                        style={{
                          opacity: record.isNew ? 0 : 1,
                        }}
                        checked={selectedRecordIds.includes(record.id)}
                        disabled={Boolean(
                          isEditing ||
                            isNoPermissionForDeleteCheckbox ||
                            (typeof configActionDisabledColumns?.checkbox ===
                            "function"
                              ? configActionDisabledColumns.checkbox(
                                  record.itemRecord as AppRecordV2,
                                  appParts,
                                )
                              : configActionDisabledColumns?.checkbox) ||
                            !canDeleteRecord,
                        )}
                        onChange={(e) =>
                          handleUnSelectedOrSelected(
                            record.id,
                            e.target.checked,
                          )
                        }
                      />
                    </span>
                  </Tooltip>
                ) : (
                  <CheckboxCustom
                    displaySize={displaySize}
                    style={{ opacity: record.isNew ? 0 : 1 }}
                    checked={selectedRecordIds.includes(record.id)}
                    disabled={Boolean(
                      isEditing ||
                        isNoPermissionForDeleteCheckbox ||
                        (typeof configActionDisabledColumns?.checkbox ===
                        "function"
                          ? configActionDisabledColumns.checkbox(
                              record.itemRecord as AppRecordV2,
                              appParts,
                            )
                          : configActionDisabledColumns?.checkbox) ||
                        !canDeleteRecord,
                    )}
                    onChange={(e) =>
                      handleUnSelectedOrSelected(record.id, e.target.checked)
                    }
                  />
                ))}
              {configActionBtnsOnRow?.reorder && (
                <div
                  {...(!isDragDisabled ? dragHandleProps : undefined)}
                  style={{ cursor: isDragDisabled ? "not-allowed" : "move" }}
                >
                  <ButtonCommonArrow
                    disabled={isDragDisabled}
                    variant="secondary"
                    style={{ marginRight: 0 }}
                  >
                    並替
                  </ButtonCommonArrow>
                </div>
              )}

              {renderButtonAction ? (
                renderButtonAction(
                  record.itemRecord as AppRecordV2,
                  refetchRecords,
                )
              ) : (
                <ButtonCommonArrow
                  disabled={
                    (!isEditingCurrentRecord && isEditing) ||
                    (appPartUserRecordPermissions && !record.isNew
                      ? !recordPermission?.record_edit
                      : !permission?.edit) ||
                    !!uploadStatus?.isUploading ||
                    !canEditRecord ||
                    (typeof configActionDisabledColumns?.editRow === "function"
                      ? configActionDisabledColumns?.editRow?.(
                          record.itemRecord as AppRecordV2,
                        )
                      : configActionDisabledColumns?.editRow)
                  }
                  onClick={() => {
                    if (isEditingCurrentRecord) handleSave(record.id);
                    else setRecordEditing(record.id);
                  }}
                  style={{ marginRight: 0 }}
                >
                  {isEditingCurrentRecord ? "保存" : "一覧編集"}
                </ButtonCommonArrow>
              )}
              {isEditingCurrentRecord && (
                <ButtonCommonArrow
                  onClick={() => {
                    setRecordEditing(null);
                    setNumberRowAddNew(0);
                  }}
                  className="cancel-btn"
                >
                  キャンセル
                </ButtonCommonArrow>
              )}
              {hasQuickView ? (
                !record.isNew && (
                  <ButtonQuickView
                    displaySize={displaySize}
                    disabled={
                      configActionDisabledColumns?.openQuickView ||
                      record.isNew ||
                      disableQuickView
                    }
                    onClick={() => {
                      setIsOpenQuickView(true);
                      setIdSelected({
                        recordId: record?.id,
                        appId: appId,
                      });
                      if (appPartUserRecordPermissions) {
                        setDisabledEdit(
                          record.isNew || !recordPermission?.record_edit,
                        );
                      } else {
                        setDisabledEdit(record.isNew || !permission?.edit);
                      }
                    }}
                  />
                )
              ) : (
                <ButtonCommonArrow
                  disabled={record.isNew}
                  arrow="right"
                  variant="secondary"
                  onClick={() => {
                    window.open(
                      `/${url}/${appId}/${ROUTES.EDIT}/${record.id}`,
                      "_blank",
                    );
                  }}
                >
                  閲覧
                </ButtonCommonArrow>
              )}
            </div>
          </div>
        );
      },
    } as Column<any>;
  }, [
    selectedRecordIds,
    recordIdEditing,
    numberRowAddNew,
    isEditing,
    filter,
    appId,
    columnWidths.columnAction,
    permission?.delete,
    permission?.edit,
    uploadStatus?.isUploading,
    isRecordEditable,
    enabledIds,
    displaySize,
  ]);

  const columnNo = useMemo(() => {
    const currentPage = hiddenPaginationInURL ? params.page : page;
    const currentPageSize = hiddenPaginationInURL ? params.pageSize : pageSize;
    return {
      dataIndex: "columnNo",
      key: "columnNo",
      width: columnWidths.columnNo ?? 36,
      fixed: "left",
      render(value, record, index) {
        const rowNo = (currentPage - 1) * currentPageSize + index + 1;
        return <div style={{ textAlign: "center" }}>{rowNo}</div>;
      },
    } as Column<any>;
  }, [params, page, pageSize, columnWidths.columnNo, hiddenPaginationInURL]);

  const columns = useMemo(() => {
    if (!appParts) return [];
    const otherColumns = orderedAppParts.map((appPart) => {
      return {
        title: (
          <Title
            item={appPart}
            isLabelVisible={true}
            filterIcon={
              <FilterIcon
                filterInfo={filterInfo}
                setFilterInfo={(newFilterInfo: any) => {
                  if (typeof newFilterInfo === "function") {
                    setFilterInfo((prev: any) => {
                      const nextInfo = newFilterInfo(prev);
                      return syncOpenFilterWithSearchBox(nextInfo, prev) as any;
                    });
                  } else {
                    setFilterInfo(
                      (prev: any) =>
                        syncOpenFilterWithSearchBox(newFilterInfo, prev) as any,
                    );
                  }
                }}
                showFilterIcon
                columnId={String(appPart.id)}
                filter={filter}
                isActive={
                  isEmpty(filter[String(appPart.id)]?.filter) &&
                  !filter[String(appPart.id)]?.filter_special_empty &&
                  !filter[String(appPart.id)]?.search?.trim()
                    ? false
                    : true
                }
              />
            }
          />
        ),
        dataIndex: appPart.id + "",
        key: appPart.id + "",
        resizeAble: true,
        width: columnWidths[String(appPart.id)] ?? getWidthByAppPart(appPart),
        render(appRecordValue: AppRecordValueV2, record, index) {
          if (
            appPart.app_part_type === APP_PART_TYPES.STATUS_CONTRACT ||
            appPart.app_part_type === APP_PART_TYPES.SIGNED_DATE
          ) {
            return (
              <CellValue
                appRecordValue={appRecordValue}
                appPart={appPart}
                selectionDataList={selectionDataList}
                record={record}
              />
            );
          }

          if (
            (record.id === recordIdEditing && numberRowAddNew === 0) ||
            record.isNew
          ) {
            const namePath = [
              String(record.id || KEY_RECORD_ADD_NEW),
              String(appPart.id),
            ];
            const disabledFieldCodes =
              DISABLED_FIELD_CODES_BY_APP_TYPE[appType] || [];
            const isDisabledByAppType = appPartUserRecordPermissions
              ? !record?.itemRecord?.policy_permissions?.record_edit
              : disabledFieldCodes.length > 0 &&
                disabledFieldCodes.includes(appPart.field_code ?? "");

            return renderField(appPart, selectionDataList, {
              namePath,
              permission,
              allowSearchDate: true,
              form,
              isDisabled: isDisabledByAppType,
              appType,
              appParts,
            });
          }
          let loading = false;
          if (SELECTIONS_APP_PARTS.includes(appPart.app_part_type)) {
            loading =
              !selectionDataList[
                appPart.app_part_type as keyof typeof selectionDataList
              ];
          }
          return (
            <Spin spinning={loading}>
              <CellValue
                appRecordValue={appRecordValue}
                appPart={appPart}
                selectionDataList={selectionDataList}
              />
            </Spin>
          );
        },
      } as Column<any>;
    });
    if (showColumnAction) {
      return [columnNo, columnAction, ...otherColumns];
    }
    return [columnNo, ...otherColumns];
  }, [
    appParts,
    orderedAppParts,
    selectionDataList,
    recordIdEditing,
    columnAction,
    columnNo,
    numberRowAddNew,
    filter,
    columnWidths,
    getWidthByAppPart,
    isEditing,
    url,
  ]);

  const handleCloseQuickView = () => {
    setIsOpenQuickView(false);
    setIdSelected({
      recordId: "",
      appId: "",
    });
  };

  const handleViewDetail = (pageMode: "view" | "edit") => {
    if (!idSelected) return;

    const addCallBackUrl = `&callBackUrl=${location.pathname}`;

    if (
      (
        [
          APP_TYPES.COMPANY_POLICIES,
          APP_TYPES.FINANCIAL_REPORTS,
          APP_TYPES.BUSINESS_TRIP_REPORTS,
          APP_TYPES.ROLE_PERMISSIONS,
          APP_TYPES.BUSINESS_FLOW,
          APP_TYPES.BUSINESS_MANUALS,
        ] as AppTypes[]
      ).includes(appType)
    ) {
      window.open(
        `/${url}/${appId}/${ROUTES.EDIT}/${
          idSelected?.recordId
        }?pageMode=${pageMode}&isDisplayInNewTab=true${
          viewType ? "&view_type=" + viewType : ""
        }${year ? `&year=${year}` : ""}${
          appType === APP_TYPES.FINANCIAL_REPORTS ? addCallBackUrl : ""
        }`,
        "_blank",
      );
    } else {
      if (isWorker) {
        window.open(
          `/${url}/${appId}/${ROUTES.EDIT}/${idSelected?.recordId}/${companyId}/${ROLE_SIGNATURE.EMPLOYEE}?pageMode=${pageMode}&isDisplayInNewTab=true`,
          "_blank",
        );
      } else {
        window.open(
          `/${url}/${appId}/${ROUTES.EDIT}/${idSelected?.recordId}/${companyId}?pageMode=${pageMode}&isDisplayInNewTab=true${addCallBackUrl}`,
          "_blank",
        );
      }
    }
  };

  const handleSetFilter = (value: any, _options: IOptions) => {
    setFilterInfo((prev: any) => {
      let newFilter = { ...prev.filter };

      // If any column has sort, clear sort from other columns
      Object.keys(value).forEach((columnId) => {
        if (value[columnId]?.sort) {
          newFilter = clearSortFromOtherColumns(newFilter, columnId);
        }
      });

      return {
        ...prev,
        filter: { ...newFilter, ...value },
      };
    });
  };

  const handleChangePagination = useCallback(
    (newPage: number, newPageSize: number) => {
      if (hiddenPaginationInURL) {
        if (newPageSize !== params.pageSize) {
          newPage = 1; // reset to first page when page size changes
        }
        setParams((pre) => ({
          ...pre,
          pageSize: newPageSize,
          page: newPage,
        }));
      } else {
        const next = new URLSearchParams(searchParams);
        if (pageSize !== newPageSize) {
          next.set("page", "1");
          next.set("per_page", String(newPageSize));
        } else if (page !== newPage) {
          next.set("page", String(newPage));
        }
        setSearchParams(next, { replace: true });
      }
    },
    [
      hiddenPaginationInURL,
      params.pageSize,
      page,
      pageSize,
      searchParams,
      setSearchParams,
    ],
  );

  useEffect(() => {
    if (hiddenPaginationInURL) {
      if (params.page > totalPages) {
        setParams((pre) => ({ ...pre, page: totalPages }));
      }
    }
  }, [totalPages, params.page, hiddenPaginationInURL]);

  useEffect(() => {
    if (isLoadingRecord || isFetchingRecord || isLoadingApp) return;
    if (!dataRecordRaw) return;
    if (!hiddenPaginationInURL) {
      const currentTotal = +(total ?? 0);
      const totalPages = Math.max(Math.ceil(currentTotal / pageSize), 1);
      const isPageOutOfRange = page > totalPages;
      const newPage = isPageOutOfRange ? totalPages : page;

      const next = new URLSearchParams(searchParams);
      if (currentTotal > 0) {
        next.set("page", `${newPage}`);
      } else {
        next.set("page", "1");
      }

      if (next.toString() === searchParams.toString()) return;

      setSearchParams(next, { replace: true });
    }
  }, [
    dataRecordRaw,
    isLoadingApp,
    isLoadingRecord,
    isFetchingRecord,
    page,
    pageSize,
    searchParams,
    setSearchParams,
    total,
    hiddenPaginationInURL,
  ]);

  useEffect(() => {
    if (restProps.forceCloseQuickViewSignal) {
      handleCloseQuickView();
    }
  }, [restProps.forceCloseQuickViewSignal]);

  useEffect(() => {
    if (!recordIdEditing) return;

    const item = dataSource?.find((item) => item.id === recordIdEditing);

    if (!item) return;

    const values = dataDataValueToForm(item, buildAppPartTypeObject(appParts));

    form.setFieldsValue({
      [recordIdEditing]: values,
    });
  }, [recordIdEditing]);

  return {
    ...restProps,
    selectionDataList,
    appParts,
    form,
    dataSource,
    columns,
    isLoadingApp,
    isLoading:
      isLoadingApp ||
      isLoadingRecord ||
      isUpdating ||
      isCreating ||
      isFetchingRecord ||
      isReordering ||
      isDeleting ||
      isSubmittingUserColumnSettings,
    selectedRecordIds,
    isDeleting,
    isOpenDeletedModal,
    onCancelModalDelete,
    handleDelete,
    handleOpenModalDelete,
    handleAddNewRow,
    refTable,
    isEditing,
    total,
    handleNavigateCreatePage,
    handleNavigateSheetPage,
    recordIdEditing,
    numberRowAddNew,
    filterInfo,
    setFilterInfo,
    filter,
    handleSetFilter,
    filterData: {},
    orderedAppParts,
    appId,
    appType,
    permission,
    showCopyButton,
    hideCreateButtons,
    handleUnSelectedOrSelectedAll,
    isOpenShareModal,
    onCancelModalShare,
    handleOpenModalShare,
    refetchRecords,
    sortableItems,
    handleDragEnd,
    columnWidths,
    columnOrder,
    handleColumnWidthsChange,
    handleColumnWidthsEnd,
    handleColumnOrderChange,
    isOpenQuickView,
    handleCloseQuickView,
    handleViewDetail,
    idSelected,
    isDisabledEdit: isDisabledEdit,
    isDisabledView,
    companyId,
    configShowBtnsOnHeader,
    configBtnQuickView,
    configActionBtnsOnRow,
    showColumnAction,
    workerId,
    displaySize,
    isEnableDeleteBtn,
    isEnableShareBtn,
    page: hiddenPaginationInURL ? params.page : page,
    pageSize: hiddenPaginationInURL ? params.pageSize : pageSize,
    handleChangePagination,
    additionalFilter,
    height,
    fontSize,
    appPartUserRecordPermissions,
  };
};

export default useAppList;
